import React, { useMemo } from 'react';
import { fetchEventVotingSessions } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';

const LoadEventLiveVoting = ({ eventId, children }) => {
    const memoizedPromise = useMemo(() => fetchEventVotingSessions(eventId).catch(console.warn), [fetchEventVotingSessions(eventId)]);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.voting.loaded} promises={[memoizedPromise]}>
            {children}
        </Loader>
    );
};

export default LoadEventLiveVoting;
